import "./AboutUs.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurIdentityAndStory from "./sections/OurIdentityAndStory";
import MissionAndVision from "./sections/MissionAndVision";
import TheInfinixValues from "./sections/TheInfinixValues";
import Philosophy from "./sections/Philosophy";
import CorporateFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <MainNavigation />
      <OurIdentityAndStory />
      <Philosophy />
      <MissionAndVision />
      <TheInfinixValues />
      <CorporateFooter />
    </div>;
}